export default __webpack_public_path__ + "css/adminTags.bundle.css";